import "../Styles/Container.css";
import doodles from "../../../public/graphics/tausta_laineet.png";
import { useEffect } from "react";
import { hideDialogue } from "../../helpers";
const Container = (props) => {
  useEffect( () => {
 hideDialogue();
 console.log("run")
  }, [])
  return (
    <>
      <div
        style={{
          position: "absolute",
          width: "100%",
          background: `linear-gradient(to bottom, var(--teini-tumma-violetti), var(--teini-vaalea-pinkki))`,
        }}
      >
        <div
          className="fullscreen-view"
          style={{
            backgroundImage: `url(${doodles})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <div className={props.class}>
            <div className="header">{props.headerText}</div>
            {props.children}
          </div>
        </div>
      </div>
    </>
  );
};

export default Container;
